import {
    cloudflareAccountParamKey,
    cloudflareDnsRecordParamKey,
    cloudflareServerParamKey,
    cloudflareZoneParamKey,
    Route,
} from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'name',
        direction: 'asc',
    })

    if (route.name.value === CloudflareRouteName.ServerAccountZones) {
        await route.addFilter({
            column: 'account_uuid',
            operator: '=',
            value: route.cloudflareAccountUuid.value,
        })
    }

    if (route.name.value === CloudflareRouteName.ServerAccountZoneRecords) {
        await route.addFilter({
            column: 'zone_uuid',
            operator: '=',
            value: route.cloudflareZoneUuid.value,
        })
    }
}

export enum CloudflareRouteName {
    Index = 'cloudflare.index',
    ServerShow = 'cloudflare.server.show',
    ServerAccountsIndex = 'cloudflare.server.accounts.index',
    ServerAccountZones = 'cloudflare.server.account.zones',
    ServerAccountZoneRecords = 'cloudflare.server.account.zone.records',
    ServerAccountZoneSetup = 'cloudflare.server.account.zone.setup',
    ServerAccountZoneRecordsCreate = 'cloudflare.server.account.zone.records.create',
    ServerAccountZoneRecordEdit = 'cloudflare.server.account.zone.record.edit',
    ServerAccountZonesCreate = 'cloudflare.server.account.zones.create',
    ServerAccountsCreate = 'cloudflare.server.accounts.create',
}

export default {
    path: '/cloudflare',
    name: CloudflareRouteName.Index,
    component: () => import('./views/Index.vue'),
    meta: {
        label: 'Cloudflare',
        auth: true,
    },
    children: [
        {
            path: `servers/:${cloudflareServerParamKey}`,
            name: CloudflareRouteName.ServerShow,
            component: () => import('./views/server/Show.vue'),
            meta: {
                label: 'Server',
                permission: Permission.CloudflareServerView,
            },
            children: [
                {
                    path: 'accounts',
                    name: CloudflareRouteName.ServerAccountsIndex,
                    component: () => import('./views/server/account/Index.vue'),
                    meta: {
                        label: 'Accounts',
                        icon: 'circle-user',
                        permission: Permission.CloudflareAccountViewAny,
                    },
                    children: [
                        {
                            path: 'create',
                            name: CloudflareRouteName.ServerAccountsCreate,
                            component: () => import('./views/server/account/Index.vue'),
                            meta: {
                                label: 'Create Account',
                                permission: Permission.CloudflareAccountCreate,
                            },
                        },
                        {
                            path: `:${cloudflareAccountParamKey}/zones`,
                            name: CloudflareRouteName.ServerAccountZones,
                            component: () => import('./views/server/account/Index.vue'),
                            meta: {
                                label: 'Account Zones',
                                permission: Permission.CloudflareZoneViewAny,
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: CloudflareRouteName.ServerAccountZonesCreate,
                                    component: () => import('./views/server/account/Index.vue'),
                                    meta: {
                                        label: 'Create Zone',
                                        permission: Permission.CloudflareZoneCreate,
                                    },
                                },
                                {
                                    path: `:${cloudflareZoneParamKey}/records`,
                                    name: CloudflareRouteName.ServerAccountZoneRecords,
                                    component: () => import('./views/server/account/Index.vue'),
                                    meta: {
                                        label: 'Zone Records',
                                        permission: Permission.CloudflareDnsRecordViewAny,
                                    },
                                    children: [
                                        {
                                            path: 'create',
                                            name: CloudflareRouteName.ServerAccountZoneRecordsCreate,
                                            component: () =>
                                                import('./views/server/account/Index.vue'),
                                            meta: {
                                                label: 'Create Zone Record',
                                                permission: Permission.CloudflareDnsRecordCreate,
                                            },
                                        },
                                        {
                                            path: `:${cloudflareDnsRecordParamKey}/edit`,
                                            name: CloudflareRouteName.ServerAccountZoneRecordEdit,
                                            component: () =>
                                                import('./views/server/account/Index.vue'),
                                            meta: {
                                                label: 'Edit Zone Record',
                                                permission: Permission.CloudflareDnsRecordUpdate,
                                            },
                                        },
                                    ],
                                },
                                {
                                    path: `:${cloudflareZoneParamKey}/setup`,
                                    name: CloudflareRouteName.ServerAccountZoneSetup,
                                    component: () => import('./views/server/account/Index.vue'),
                                    meta: {
                                        label: 'Zone Setup',
                                        permission: Permission.CloudflareZoneCreate,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
}
